module.exports = __webpack_public_path__ + "static/media/scroll4_phone2.c563db33.png";